(() => {
  function init(root = document) {
    root.querySelectorAll('[data-lbr-rail]').forEach(rail => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const section = rail.closest('.lbr-section');
      const prev = section.querySelector('[data-lbr-prev]');
      const next = section.querySelector('[data-lbr-next]');
      const update = () => {
        prev.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      const move = direction => rail.scrollBy({left: direction * (rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(rail);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.querySelectorAll('.lbr-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
})();
